import { render, staticRenderFns } from "./PolicyCard.vue?vue&type=template&id=2878f732&scoped=true"
import script from "./PolicyCard.vue?vue&type=script&lang=js"
export * from "./PolicyCard.vue?vue&type=script&lang=js"
import style0 from "./PolicyCard.vue?vue&type=style&index=0&id=2878f732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878f732",
  null
  
)

export default component.exports